import type { RouteConfig } from 'vue-router';
import { Role } from '@/modules/shared/types';

const route: RouteConfig = {
    path: '/:customer/customer/:customerKey/users/:userKey/generators',
    name: 'customer-user-generators',
    component: () => import(/* webpackChunkName: "ctx-admin-customers" */ './UserGeneratorsView.vue'),
    meta: {
        role: Role.APP_ADMIN,
        license: [],
        authenticated: true,
        navbar: true,
        footer: true,
        settingsTabs: false,
        portfolioTabs: false,
        onboarding: true,
        notifications: true,
    },
};

export { route };
